// extracted by mini-css-extract-plugin
export default {"root":"_117Ha","icon":"_2b51D","tooltip":"_7uAwd"};